import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MultiTaskActionComponent } from './multiTaskAction.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { DivisionDetailModule } from '../../dossiers/components/divisionDetail.module';
import { TableModule } from 'primeng-lts/table';
import { ConfirmationService } from 'primeng-lts/api';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [MultiTaskActionComponent],
  imports: [TranslateModule, CommonModule, FormsModule,
    SubHeaderModule, ScrollPanelModule, CheckboxModule, DivisionDetailModule,
    OverlayPanelModule, TableModule, ProgressBarModule],
  exports: [MultiTaskActionComponent],
  providers: [ConfirmationService, DialogService],
})
export class MultiTaskActionModule { }
